import { ORIAS_NUMBER, ORIAS_REGISTER_URL } from "@/app/constants/organization"

// Code des assurances R521-1: an intermediary must show its ORIAS number and where to verify it.
export default function FooterLegalLead({ className }: { className?: string }) {
    return (
        <p className={className}>
            Réassurez-moi est courtier en assurance emprunteur et mutuelle santé qui vous aide à trouver le meilleur
            contrat avec des comparateurs intelligents et des experts dédiés pour vous. Courtier en assurances
            immatriculé à l&apos;ORIAS sous le n° {ORIAS_NUMBER}, registre consultable sur{" "}
            <a className="underline" href={ORIAS_REGISTER_URL} target="_blank" rel="noopener noreferrer">
                www.orias.fr
            </a>
            .
        </p>
    )
}
